module.exports = __webpack_public_path__ + "img/criminal_case_part_2_splash.71805706.jpg";